export default "__VITE_ASSET__D_F0Dxb4__"